module.exports = __webpack_public_path__ + "static/sasi-1a96f7aad037d8a6aebc551e5a83b2e6.svg";